// Returns the type of device the panel is being accessed from, using the same
// vocabulary the backend derives from ua-parser ('mobile' | 'tablet' |
// 'desktop'), so events tracked from both sides can be segmented together.
export const getDeviceType = () => {
    // Chromium states it outright, which is both more reliable than sniffing
    // the string and the only signal left on phones whose user-agent was
    // reduced. It only claims phones, so tablets still fall through below.
    if (window.navigator?.userAgentData?.mobile) return 'mobile';

    const userAgent = window.navigator?.userAgent || '';

    // Tablets have to be checked before phones: an Android tablet carries the
    // same 'Android' token as a phone and is only told apart by the absence of
    // the 'Mobi' one.
    if (/iPad|Tablet|PlayBook|Silk/i.test(userAgent)) return 'tablet';
    if (/Android/i.test(userAgent) && !/Mobi/i.test(userAgent)) return 'tablet';

    // iPadOS asks for the desktop site by default, so it reports a Macintosh
    // user-agent and the touch points are the only thing separating it from an
    // actual Mac.
    if (/Macintosh/.test(userAgent) && window.navigator?.maxTouchPoints > 1) return 'tablet';

    if (/Mobi|iPhone|iPod|Android|Windows Phone/i.test(userAgent)) return 'mobile';

    return 'desktop';
}
